import ReactDOM from "react-dom";
import App from "./App.js";
import "./assets/main.scss";
import {
    BrowserRouter as Router,
  } from "react-router-dom";

ReactDOM.render(<Router><App /></Router>, document.getElementById("root"));